import { COMPACT_SHELL_MAX_WIDTH_PX } from "./layoutBreakpoints";

/**
 * Viewports at or below this width use the compact shell (hamburger nav, drawers,
 * mobile typography, full-screen project modal, etc.). Desktop layout starts at 1024px.
 * iPad Pro portrait/landscape (≥1024) keeps the desktop shell; tablet CSS applies via layout mode.
 */
export { COMPACT_SHELL_MAX_WIDTH_PX };

export const compactShellMediaQuery = `(max-width: ${COMPACT_SHELL_MAX_WIDTH_PX}px)`;

/** @deprecated Prefer COMPACT_SHELL_MAX_WIDTH_PX — kept for existing imports */
export const MOBILE_MAX_WIDTH_PX = COMPACT_SHELL_MAX_WIDTH_PX;

/** @deprecated Prefer compactShellMediaQuery */
export const mobileMediaQuery = compactShellMediaQuery;
